import { EmployeeType } from '@avanzu/types';
import { Person, PersonOutline } from '@mui/icons-material';

export const EmployeeIcon = ({ isActive, type }: { isActive: boolean; type: EmployeeType }) => {
  return type === EmployeeType.EMPLOYEE ? (
    <Person
      sx={{
        fontSize: 16,
        verticalAlign: 'middle',
        mr: 0.5,
        pb: 0.2,
        color: isActive ? 'success.main' : 'error.main',
      }}
    />
  ) : (
    <PersonOutline
      sx={{
        fontSize: 16,
        verticalAlign: 'middle',
        mr: 0.5,
        pb: 0.2,
        color: isActive ? 'success.main' : 'error.main',
      }}
    />
  );
};

export default EmployeeIcon;
